import { render, staticRenderFns } from "./PlainTextResponse.vue?vue&type=template&id=5b8490d4&scoped=true&"
import script from "./PlainTextResponse.vue?vue&type=script&lang=ts&"
export * from "./PlainTextResponse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8490d4",
  null
  
)

export default component.exports